import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { Flex as i, Box as S, Text as B } from "@chakra-ui/react";
import { MinusButton as z } from "./minus-button.js";
import { PlusButton as L } from "./plus-button.js";
import { ThemeFontSizeVariable as s, ThemeColorVariable as t, ThemeRadiusVariable as T, ThemeBorderVariable as C, ThemeFontVariable as V } from "../../theme/theme-types.js";
function X({
  size: c = "sm",
  quantity: r = 0,
  onClickPlus: m,
  onClickMinus: d,
  minusButtonAriaLabel: u = "decrease",
  plusButtonAriaLabel: b = "increase",
  min: f = 0,
  max: h = 99,
  disabled: a = !1,
  ...p
}) {
  const o = c === "lg", n = o ? "160px" : "120px", l = o ? "lg" : "md", g = o ? s.XLarge : s.Large;
  return /* @__PURE__ */ e(i, { w: n, ...p, children: /* @__PURE__ */ e(
    S,
    {
      border: C.XSmall,
      borderColor: t.OnBackgroundBorder,
      borderRadius: T.XLarge,
      backgroundColor: t.Surface,
      opacity: 0.88,
      children: /* @__PURE__ */ x(i, { justify: "space-between", position: "relative", zIndex: 1, w: n, children: [
        /* @__PURE__ */ e(
          z,
          {
            onClick: d,
            ariaLabel: u,
            buttonSize: l,
            isDisabled: r <= f || a
          }
        ),
        /* @__PURE__ */ e(
          i,
          {
            justify: "center",
            align: "center",
            userSelect: "none",
            zIndex: -1,
            left: "0",
            right: "0",
            ml: "auto",
            mr: "auto",
            position: "absolute",
            h: "100%",
            children: /* @__PURE__ */ e(
              B,
              {
                fontFamily: V.SubHeader,
                fontWeight: "normal",
                fontSize: g,
                color: t.OnSurface,
                children: r
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          L,
          {
            isDisabled: r >= h || a,
            onClick: m,
            ariaLabel: b,
            buttonSize: l
          }
        )
      ] })
    }
  ) });
}
export {
  X as QuantityButton
};
